import React, { useEffect, useCallback, useState} from 'react';
import EffectParameterSlider from "components/effects/EffectParameterSlider.js";
import {connect} from 'react-redux';

const TidalVariables = ({sequencerEngine, variables=[]}) => { 
    return (
        <div className="tidal-variables">
          {(variables || []).map(
                variable =>
                    <EffectParameterSlider
                      name={variable.name}
                      min={variable.min}
                      max={variable.max}
                      step={variable.max - Math.floor(variable.max) !== 0 ||
                             variable.min - Math.floor(variable.min) !== 0 ||
                             Math.abs(variable.max - variable.min) < 2 ? 0.01 : 1}
                      parameter={variable}
                      lfoEnabled={true}
                      sequencerEngine={sequencerEngine}
                      isParameter={true}
                      effectNumber={0}
                    />)}
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
        variables: state.effects.scriptVariables[props.tidal.id],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TidalVariables);
